const header = "_35sh11pidm5";
const fragment = "_35sfs2a33l";
const date = "_35sd1g5uea4";

export { date, fragment, header };
import "./molecule.header.style.linaria.module.css";
//# sourceMappingURL=molecule.header.style.js.map
